
import { RefreshCw } from "lucide-react";

interface AgentWaitingIndicatorProps {
  onDismiss?: () => void;
}

export function AgentWaitingIndicator({ onDismiss: _onDismiss }: AgentWaitingIndicatorProps = {}) {
  return (
    <div className="flex items-center justify-start pl-7 gap-2 text-xs text-stone-500 py-2 animate-in fade-in duration-200">
      <RefreshCw className="w-3.5 h-3.5 animate-spin text-stone-400 shrink-0" />
      <span className="text-[11px]">
        Analyzing prompt &amp; orchestrating workflow activities...
      </span>
    </div>
  );
}
